import React, { memo } from 'react';
import classNames from 'classnames/bind';
import { Text } from '@beef/ui-kit';
import styles from "./styles.module.pcss";
var cn = classNames.bind(styles);
export var ServiceContent = /*#__PURE__*/memo(function (_ref) {
  var _ref$price = _ref.price,
    price = _ref$price === void 0 ? {
      value: '',
      unit: ''
    } : _ref$price,
    title = _ref.title,
    subtitle = _ref.subtitle,
    note = _ref.note;
  var priceText = price !== null && price !== void 0 && price.value ? "".concat(price === null || price === void 0 ? void 0 : price.value, " \u20BD") : price.value;
  var unitText = "/ ".concat(price.unit);
  return /*#__PURE__*/React.createElement("div", {
    className: cn('content-container'),
    "data-t-id": "components-ServiceContent"
  }, title && /*#__PURE__*/React.createElement(Text, {
    size: "size4-m"
  }, title), subtitle && /*#__PURE__*/React.createElement(Text, {
    color: "grey60",
    size: "size5-r-l"
  }, subtitle), /*#__PURE__*/React.createElement("div", {
    className: cn('price-container')
  }, /*#__PURE__*/React.createElement(Text, {
    size: "size1-m"
  }, priceText), price.unit && /*#__PURE__*/React.createElement(Text, {
    color: "grey60",
    size: "size5-r-s"
  }, unitText)), note && /*#__PURE__*/React.createElement(Text, {
    color: "grey60",
    size: "size6-r"
  }, note));
});